import {
  Control,
  Controller,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import TextEditor from '../../../../../shared/editor/text-editor';
import { useRef } from 'react';
import { Editor } from 'tinymce';
import { ActionErrorEntry } from '../decom-policy-utils.tsx';
import AllFields from '../../../../user-management/user-details/gmail-settings/signatures/all-fields.tsx';
import { DecomPolicyFormValues } from '../decom-policy-form-layout.tsx';
import { clearFieldError } from './decom-action.tsx';

import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface VacationResponderStepProps {
  control: Control<DecomPolicyFormValues>;
  watch: UseFormWatch<DecomPolicyFormValues>;
  setValue: UseFormSetValue<DecomPolicyFormValues>;
  clearErrors: UseFormClearErrors<DecomPolicyFormValues>;
  errors: FieldErrors<DecomPolicyFormValues>;
  setActionTypesWithErrors: React.Dispatch<
    React.SetStateAction<ActionErrorEntry[]>
  >;
  day: number;
}

export default function VacationResponderStep({
  control,
  watch,
  errors,
  clearErrors,
  setValue,
  setActionTypesWithErrors,
  day,
}: VacationResponderStepProps) {
  const actionsData = watch(`actions.${day}.actions`) || [];
  const idx = actionsData
    .map((action) => action.actionType)
    .indexOf('vacationResponder');
  const editorRef = useRef<Editor | null>(null);

  return (
    <Stack
      sx={{
        viewTransitionName: 'steps',
        p: 1,
        pb: 2,
      }}
      gap={1}
      width={'100%'}
    >
      <Controller
        name={`actions.${day}.actions.${idx}.subject`}
        control={control}
        render={({ field }) => (
          <TextField
            id="subject"
            label="Subject"
            required
            {...field}
            onChange={(e) => {
              field.onChange(e);
              setValue(
                `actions.${day}.actions.${idx}.subject`,
                e.target.value,
                {
                  shouldValidate: true,
                  shouldDirty: true,
                }
              );
              clearFieldError(
                'vacationResponder',
                'subject',
                setActionTypesWithErrors
              );
              clearErrors(`actions.${day}.actions.${idx}.subject`);
            }}
            sx={{ width: 300 }}
            autoComplete="off"
            error={!!errors?.actions?.[day]?.actions?.[idx]?.subject}
            helperText={
              errors?.actions?.[day]?.actions?.[idx]?.subject?.message || ' '
            }
          />
        )}
      />
      <AllFields
        excludeSendAs={true}
        excludeConditional={true}
        editorRef={editorRef}
      />
      <Box
        sx={
          errors?.actions?.[day]?.actions?.[idx]?.message
            ? {
                width: '100%',
                height: 400,
                border: (theme) => `1px solid ${theme.palette.error.main}`,
                borderRadius: 3,
              }
            : { width: '100%', height: 400 }
        }
      >
        <Controller
          name={`actions.${day}.actions.${idx}.message`}
          control={control}
          render={({ field }) => (
            <TextEditor
              editorRef={editorRef}
              content={field.value! as string}
              setContent={(val) => {
                field.onChange(val);
                setValue(`actions.${day}.actions.${idx}.message`, val, {
                  shouldValidate: true,
                  shouldDirty: true,
                });
                clearFieldError(
                  'vacationResponder',
                  'message',
                  setActionTypesWithErrors
                );
                clearErrors(`actions.${day}.actions.${idx}.message`);
              }}
            />
          )}
        />
        <FormHelperText error sx={{ mt: 1, ml: 1 }}>
          {errors?.actions?.[day]?.actions?.[idx]?.message
            ? errors?.actions?.[day]?.actions?.[idx].message.message
            : ' '}
        </FormHelperText>
      </Box>
    </Stack>
  );
}
